import React from 'react';
import MUIDataTable from 'mui-datatables';
import useTeamProvider from '../useTeamProvider';

import LoadingPageText from '../../../common/Loading/LoadingPageText';
import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import AssignmentDetailsSidePanel from './AssignmentDetailsSidePanel';
import NonBlockingLoader from '../../../common/Loading/NonBlockingLoader';

import { useRequestLogs } from '../../../../actions/areas/admin/fetchHooks/fetchExternalProvider';
import { tableSettings } from './requestLogsTableSettings';
import globals from '../../../../globals/communityGlobals';
import { getDateForApi } from '../../../../utils/dates';

const locale = globals.getAreas(['externalProvider', 'error']);

export default function RequestLogsContent() {
  document.title = 'Provider Request Logs';

  const {
    forceReload,
    orgUnitId,
    getStateVisitId,
    pageSize,
    currentPage,
    sortColumn,
    sortDirection,
    selectedAllForSending,
    requestIds,
    fromDate,
    toDate,
    requestStatus,
    openSidePanel,
    message,
    showSnackbar,
    handleCancel,
    handleConfirm,
    handleCloseSnackBar,
    actionName,
    showActionConfirmation,
  } = useTeamProvider();

  const model = {
    orgUnitId,
    fromDate: getDateForApi(fromDate),
    toDate: getDateForApi(toDate),
    status: requestStatus,
    visitId: getStateVisitId,
    pageSize,
    currentPage,
    sortColumn,
    sortDirection,
  };
  const { data, isDataLoading, isTableDataLoading } = useRequestLogs(model, forceReload);

  const settings = tableSettings({
    count: data.totalCount,
    page: data.currentPage - 1,
    pageSize: data.pageSize,
    sortColumn,
    isTableDataLoading,
  });

  if (isDataLoading)
    return (
      <LoadingPageText showHeader={false}>Wait a moment while we gather Request Logs list info...</LoadingPageText>
    );

  return (
    <div className="page-content-wrapper">
      <MUIDataTable title={settings.name} data={data.items} columns={settings.columns} options={settings.options} />
      <ConfirmationDialog
        open={showActionConfirmation}
        handleCancel={handleCancel}
        handleConfirm={() => handleConfirm(actionName, requestIds, selectedAllForSending)}
        title={locale.getMsg('requestActionTitle', [actionName])}
        text={locale.getMsg('requestActionText', [actionName])}
      />
      {message && (
        <NonBlockingLoader
          open={showSnackbar}
          message={message}
          autohideDuration={5000}
          closeSnackbar={handleCloseSnackBar}
        />
      )}
      {openSidePanel && <AssignmentDetailsSidePanel />}
    </div>
  );
}
